import ptBrTranslations from './pt-br'
import enUsTranslations from './en-us'
import esTranslations from './es-ar'

export default {
  'pt-BR': ptBrTranslations,
  'en-US': enUsTranslations, 
  'es': esTranslations
}